<template>
    <v-sheet>
        <div class="d-flex mt-2 flex-grow-1 flex-shrink-0 align-center justify-space-around">
                <v-label>Filtra</v-label>
                <v-autocomplete dense outlined
                    class="ml-4"
                    :items=Object.keys(families)
                    append-icon="filter_list"
                    clearable
                    hide-details
                    v-model="search_family"
                    label="famiglia">
                    </v-autocomplete>
                    <v-autocomplete dense outlined
                    class="ml-2"
                    :items=Object.values(op_types)
                    apepend-icon="filter_list"
                    item-text="name"
                    item-value="id"
                    clearable
                    hide-details
                    v-model="search_report"
                    label="report">
                </v-autocomplete>
                <v-btn class="ml-6" color="primary" @click="searchMasters"><v-icon small>search</v-icon></v-btn>
                <v-btn class="ml-2" color="action" @click="clearSearch"><v-icon small>clear</v-icon></v-btn>
            </div>
        <v-sheet class="ma-0 pa-0">
            <BasicCard>
                <template v-slot:action>
                    <v-btn v-can="{obj_type:'master', action: 'edit'}" class="ml-2 white--text" text @click.stop="editMaster(null)"><v-icon class="pa-2" small>add_box</v-icon> Nuovo master</v-btn>
                </template>
                <div v-if="loading" class="d-flex justify-center">
                    <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
                </div>
                <v-data-table
                    v-else
                    :headers="headers"
                    :items="masters"
                    hide-default-footer
                    disable-pagination
                    >
                    <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="(item, index) of items" :key="item._id+'_'+item._rev" >
                            <td class="text-left"><v-icon small class="pr-1">{{ item.active ? 'visibility': 'visibility_off'}}</v-icon>{{item.name}}</td>
                            <td class="text-left">{{item.family}}</td>
                            <td class="text-left">{{op_types[item.op_type].prefix}}</td>
                            <td class="text-left">{{item.master_rev}}</td>
                            <td class="text-left">{{item.updated | formatDateTS}}</td>
                            <td class="text-right">
                                <div class="d-flex align-center justify-end">
                                    <v-btn v-can="{obj_type:'master', action: 'edit'}" color="primary" class="ma-1" small @click.stop="changeMasterStatus(item, index)">
                                        <span v-if="item.active">disattiva</span><span v-else>attiva</span>
                                    </v-btn>
                                    <v-btn v-can="{obj_type:'master', action: 'edit'}" color="primary" class="ma-1" small fab @click.stop="editMaster(item._id)"><v-icon small>edit</v-icon></v-btn>
                                    <v-btn v-can="{obj_type:'master', action: 'edit'}" color="primary" class="ma-1" small fab @click.stop="cloneMaster(item._id)"><v-icon small>file_copy</v-icon></v-btn>
                                    <v-btn v-can="{obj_type:'master', action: 'edit'}" color="primary" class="ma-1" small fab @click.stop="openDeleteConfirm(index, item)"><v-icon small>delete</v-icon></v-btn>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    </template>
                </v-data-table>
            </BasicCard>
            <div v-if="masters.length > 0" class="text-center pa-2">
                <div class="text-right font-italic font-small">Totale: {{ masters.length }}</div>
            </div>
        </v-sheet>
        <ConfirmDialog
            v-bind:data="delete_confirm"
            v-on:close_dialog="closeDialog"
            v-on:confirm_result="onDeleteConfirm"/>
    </v-sheet>
</template>

<script>
// import _ from 'lodash'
import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import {i_families, report_type} from "../../utils/common.js"
import BasicCard from '../../components/utils/Basic_card'
export default {
    components:{ConfirmDialog, BasicCard},
    data(){
        return {
            headers: [
                {text: 'nome', value: 'name', align:'left', sortable: false},
                {text: 'famiglia', value: 'family', align:'left', sortable: false},
                {text: 'report', value: 'op_type', align:'left', sortable: false},
                {text: 'revisione', value: 'revision', align:'left', sortable: false},
                {text: 'aggiornato il', value: 'updated', align:'left', sortable: false},
                {text: '', value: '', align:'left', sortable: false}
            ],
            op_types: report_type,
            families: i_families,
            search_report: null,
            search_family: null,
            loading: true,
            masters: [],
            delete_confirm: {
                index: null,
                dialog: false,
                doc: null,
                title: 'Elimina master',
                message: "Sei sicuro di voler rimuovere il master selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
                },
        }
    },
    methods: {
        async searchMasters(){
            this.loading = true
            let selector = {doc_type: 'master'}
            if (this.search_family!=null){
                selector['family'] = this.search_family
            }
            if (this.search_report!=null){
                selector['op_type'] = this.search_report
            }
            this.$store.commit('setSearchParam', { path: this.$router.history.current.fullPath, filter: {search_family: this.search_family, search_report: this.search_report} })
            
            console.log('selector', selector)
            let res = await this.$store.state.$pouch.find('masters', {
                selector: selector
            })
            this.masters = res.docs
            this.loading=false
        },
        openDeleteConfirm(index, doc){
            console.log('DELETE', index, doc)
            this.delete_confirm.dialog = true;
            this.delete_confirm.index = index;
            this.delete_confirm.doc = doc;
        },
        clearSearch() {
            this.search_family = null
            this.search_report = null
            this.searchMasters()
        },
        editMaster(m_id) {
            this.$router.push({name: "editMaster", query: {m_id: m_id, clone: "false"}})
        },
        cloneMaster(m_id) {
            this.$router.push({name: "editMaster", query: {m_id: m_id, clone: "true"}})
        },
        viewMaster(m_id) {
            this.$router.push({name: "editMaster", query: {m_id: m_id, clone: "false", preview: "true"}})
        },
        async changeMasterStatus(item) {
            let master = await this.$store.state.$pouch.get('masters', item._id)
            if (master.active == item.active && master._rev == item._rev) {
                master.active = !master.active;
                master.updated_by = this.$store.state.user._id
                master.updated = (new Date()).getTime()
                let res = await this.$store.state.$pouch.put('masters', master).catch(error => {
                    console.log('error', error)
                })
                if (res && res.ok) {
                    item.active = master.active
                    this.$set(item, '_rev', res.rev)
                }
            } else {
                // force reload page
            }
            
        },
        async onDeleteConfirm(choice){
            try {
                if(choice == "delete"){
                    let doc = _.cloneDeep(this.delete_confirm.doc)
                    doc._deleted = true
                    doc.updated_by = this.$store.state.user._id
                    doc.updated = (new Date()).getTime()
                    let res = await this.$store.state.$pouch.put('masters', doc)
                    if (res.ok) {
                        this.masters.splice(this.delete_confirm.index, 1)
                        console.log('master removed')
                    }
                }
                this.closeDialog()
            } catch (error) {
                console.log('error', error)
            }
        },
        closeDialog(){
            this.delete_confirm.dialog = false;
        }
        
        
    },
    mounted(){
        let filter = this.$store.state.search[this.$router.history.current.fullPath]
        if (filter) {
            if (filter.search_family!=null){
                this.search_family = filter.search_family
            }
            if (filter.search_report!=null){
                this.search_report = filter.search_report
            }
        }
        this.searchMasters()
    },
    created(){
    }
}
</script>
